import React, { useState, useEffect } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

function TopHeader2({ page_name,pageset }) {
    const apiData = useSelector((state) => state.questionResult.apiData);
    const pagestep = useSelector((state) => state.counter.value);
    const result = useSelector((state) => state.result.scores);
    console.log('pagestpagesteppagestepep',pagestep);
    const [data, setData] = useState(apiData?.data || {});
    const [currentIndex, setCurrentIndex] = useState(0);
    const [timeLeft, setTimeLeft] = useState(300);
    const [timerActive, setTimerActive] = useState(false);

     //const total = data?.Total || 0;
      
       const total = data?.[pageset]?.Total || 0;
    // Keep local data synced with Redux apiData
    useEffect(() => {
        setData(apiData?.data || {});
    }, [apiData]);

    // Timer logic
    useEffect(() => {
        if (!timerActive) return;

        const intervalId = setInterval(() => {
            setTimeLeft((prev) => {
                if (prev <= 1) {
                    clearInterval(intervalId);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(intervalId);
    }, [timerActive]);

    // Handle pagestep changes
    useEffect(() => {
        if ([4, 6, 8,10].includes(pagestep)) {
            setTimeLeft(180);
            setTimerActive(true);
        } else if ([3, 5, 7, 9].includes(pagestep)) {
            setTimeLeft(180);
            setTimerActive(false);
        }
    }, [pagestep]);

    // Time formatting
    const minutes = String(Math.floor(timeLeft / 60)).padStart(2, '0');
    const seconds = String(timeLeft % 60).padStart(2, '0');

    return (
        pagestep > 2 && (
            <Box sx={{ maxWidth: 800, margin: 'auto', p: 4, textAlign: 'center' }}>
                {/* Header */}
                <Grid
                    container
                    sx={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        background: '#62499c',
                        borderBottom: '4px solid #ffc107',
                        color: '#fff',
                        zIndex: 1000,
                        px: 2,
                        py: 1,
                    }}
                >
                    <Grid item xs={12}>
                        <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
                            {/* Left side: Icon + Page Name */}
                            <Box display="flex" alignItems="center">
                                <img
                                    src="images/Picture9.png"
                                    alt="Listening Activity Icon"
                                    style={{ width: 60, height: 60 }}
                                />
                                <Typography variant="h6" ml={2}>
                                    {page_name}
                                </Typography>
                            </Box>

                            {/* Right side: Question number */}
                            {pagestep !== 11 && (
                                <Typography variant="body1" style={{ fontSize: '25px' }}>
                                    Question {currentIndex + 1}/{total}
                                </Typography>
                            )}
                        </Box>
                    </Grid>
                </Grid>

                {/* Timer */}
                {pagestep !== 11 && (
                    <Grid
                        container
                        sx={{
                            position: 'fixed',
                            top: 76,
                            right: 0,
                            width: 'auto',
                            color: '#fff',
                            backgroundColor: '#ffb40b',
                            p: 2,
                            zIndex: -9,
                            textAlign: 'right',
                        }}
                    >
                        <Grid item xs={12} display="flex" alignItems="center" gap={1}>
                            <img
                                src="images/Picture20.png"
                                alt="Timer Icon"
                                style={{ width: 50, height: 50 }}
                            />
                            <Typography variant="h4" component="span" className="clockfile">
                                {minutes}:{seconds}
                            </Typography>
                        </Grid>
                    </Grid>
                )}
            </Box>
        )
    );
}

export default TopHeader2;
